import {
  canGetBgysLayoutPages,
  canGetDdoLayoutPages,
  canGetGdprLayoutPages,
  canGetKvkkLayoutPages,
  canGetOrganizationSettingsPage,
  canGetRiskLayoutPages,
  isAccountTypeSystem,
  isAdminOrOwnerOfAnyWorkpace,
  isLoggedIn,
  isNotLoggedIn,
  isOrganizationSelected,
} from "@/route-authorization";
import loader from "@/router/loader";
import forbidden from "@c/forbidden";
import PageNotFound from "@c/not-found";

const loadedRoutes = loader();

function prepareChildren(moduleName, ruleProps = [], dynamicRules = () => []) {
  return (loadedRoutes[moduleName] || []).map((i) => {
    const meta = i.meta ?? { rules: [] };
    i.meta = { ...meta, rules: [...meta.rules, ...ruleProps, ...(dynamicRules(i.path) ?? [])] };
    return i;
  });
}
export default [
  {
    path: "/gdpr",
    name: "gdpr",
    component: () => import("@/layouts/gdpr"),
    children: [...prepareChildren("gdpr", [isLoggedIn, isOrganizationSelected, canGetGdprLayoutPages])],
    meta: { rules: [isLoggedIn, isOrganizationSelected, canGetGdprLayoutPages] },
  },
  {
    path: "/kvkk",
    name: "kvkk",
    component: () => import("@/layouts/kvkk"),
    children: [...prepareChildren("kvkk", [isLoggedIn, isOrganizationSelected, canGetKvkkLayoutPages])],
    meta: { rules: [isLoggedIn, isOrganizationSelected, canGetKvkkLayoutPages] },
  },
  {
    path: "/ddo",
    name: "ddo",
    component: () => import("@/layouts/ddo"),
    children: [...prepareChildren("ddo", [isLoggedIn, isOrganizationSelected, canGetDdoLayoutPages])],
    meta: { rules: [isLoggedIn, isOrganizationSelected, canGetDdoLayoutPages] },
  },
  {
    path: "/bgys",
    name: "bgys",
    component: () => import("@/layouts/bgys"),
    children: [...prepareChildren("bgys", [isLoggedIn, isOrganizationSelected, canGetBgysLayoutPages])],
    meta: { rules: [isLoggedIn, isOrganizationSelected, canGetBgysLayoutPages] },
  },
  {
    path: "/risk",
    name: "risk",
    component: () => import("@/layouts/risk"),
    children: [...prepareChildren("risk", [isLoggedIn, isOrganizationSelected, canGetRiskLayoutPages])],
    meta: { rules: [isLoggedIn, isOrganizationSelected, canGetRiskLayoutPages] },
  },
  {
    path: "/",
    name: "platform",
    component: () => import("@/layouts/dashboard/platform"),
    children: [...prepareChildren("platform", [isLoggedIn])],
    meta: { rules: [isLoggedIn] },
  },
  {
    path: "/help-center",
    name: "help-center",
    component: () => import("@modules/help-center/index.vue"),
    children: [...prepareChildren("helpCenter", [isLoggedIn])],
    meta: { rules: [isLoggedIn] },
  },
  {
    path: "/management",
    name: "management",
    component: () => import("@/layouts/management"),
    children: [...prepareChildren("management", [isLoggedIn, isAccountTypeSystem])],
    meta: { rules: [isLoggedIn, isAccountTypeSystem] },
  },
  {
    path: "/organization",
    name: "organization",
    component: () => import("@/layouts/organization"),
    children: [...prepareChildren("organization", [isLoggedIn, canGetOrganizationSettingsPage])],
    meta: { rules: [isLoggedIn] },
  },
  {
    path: "/account",
    name: "account",
    component: () => import("@/layouts/account"),
    children: [...prepareChildren("account", [isLoggedIn])],
    meta: { rules: [isLoggedIn] },
  },
  {
    path: "/workspace",
    name: "workspace",
    component: () => import("@/layouts/workspace"),
    children: [
      ...prepareChildren("workspace", [isLoggedIn], (path) => {
        //if (["/library/", "members", "organizations"].find((p) => path.includes(p))) {
        return [isAdminOrOwnerOfAnyWorkpace];
        //}
      }),
    ],
    meta: { rules: [isLoggedIn] },
  },
  {
    path: "/login",
    name: "login",
    component: () => import("@/modules/account/login-view"),
    meta: { rules: [isNotLoggedIn] },
  },
  {
    path: "/mail",
    name: "mail",
    component: () => import("@/modules/mail-log/mail"),
  },
  {
    path: "/forgot-password",
    name: "Forgot password",
    component: () => import("@/modules/account/forgot-password-view"),
  },
  {
    path: "/reset-password/:token",
    name: "Reset password",
    component: () => import("@/modules/account/reset-password-view"),
  },
  {
    path: "/activation/:token",
    name: "activation",
    component: () => import("@/modules/account/activation-view"),
  },

  {
    path: "/logout",
    name: "logout",
  },
  {
    path: "/register",
    name: "register",
    component: () => import("@/modules/account/register-view"),
  },
  {
    path: "/403",
    component: forbidden,
  },
  {
    path: "*",
    component: PageNotFound,
  },
];
